<prlw-mobile-footer-ui
  [menuItems]="items"
  (eventClick)="handleEventClick($event)"
  (eventShowFeedbackOverlay)="handleShowFeedbackOverlay()"
></prlw-mobile-footer-ui>
